import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingHelper {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private reqs = 0;

  constructor() {}

  connect() {
    return this.loadingSubject.asObservable();
  }

  show() {
    this.reqs++;
    this.loadingSubject.next(true);
  }

  hide() {
    if (--this.reqs <= 0) {
      this.reqs = 0;
      this.loadingSubject.next(false);
    }
  }
}
